export const colors = {
   // bg_dark: '#010915ba',
   bg_dark: '#000000de',
   hover_effect_link: 'darkblue',
   bg_red: '#de4939',
   bg_red_trans: '#de49399e',
   text_white: 'white',
   dark_text: 'black',
   green_avatar: 'green'
}